var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "final-payment-modal-template" },
    _vm._l(_vm.paragraphs, function (text, index) {
      return _c("p", { key: index }, [_vm._v("\n    " + _vm._s(text) + "\n  ")])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }